/* Packages */
import React from "react";

/* Components */
import {Button} from '../../common';

export default function ConversionConfirmation({
    stepData,
    closeModal
}) {
    /* Constants */
    const { thankYouTextHeading, thankYouText } = stepData;

    /* Render */
    return (
        <>
            <h3 className="h2 mb-0">{thankYouTextHeading}</h3>
            <div className="row gutters-3 gutters-xl-6">
                <div className="col-12 col-lg-10 col-xl-9">
                    <div className="row gutters-4">
                        <div className="col-12">
                        </div>
                        <div className="col-12">
                            <p className="lead">{thankYouText}</p>
                        </div>
                        <div className="col-12 col-lg-auto">
                            <Button 
                                classes="btn-block mt-lg-4"
                                linkTitle="Sluit dit venster"
                                onClick={closeModal}
                            />
                        </div>
                    </div>
                </div>
            </div>            
        </>
    );
}
